import { cloneElement, Component } from "react"
import { get } from "lodash"
import PropTypes from "prop-types"
import classNames from "classnames"
import { Slide, Dialog as MUIDialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material"
import Loading from "components/loading"
import "./style.scss"
import withNavigate from "hocs/withNavigate"

class Dialog extends Component {
  static propTypes = {
    close: PropTypes.func.isRequired,
    opened: PropTypes.bool.isRequired,
    open: PropTypes.func.isRequired,
    trackAction: PropTypes.func.isRequired,
    settings: PropTypes.object.isRequired,
    superModalOpened: PropTypes.bool,
    navigate: PropTypes.func.isRequired,
  }

  onApply = (action, trackType, trackPayload = null, preventClose = false) => {
    const settings = get(this, "props.settings", {})
    return () => {
      if (!preventClose) {
        this.props.close()
        settings.onClose && settings.onClose()
      }
      if (trackType) this.props.trackAction(trackType, trackPayload)
      action({ navigate: this.props.navigate })
    }
  }

  onClose = (event, reason) => {
    const settings = get(this, "props.settings", {})
    if (settings.disableBackdropClick && reason === "backdropClick") {
      event.preventDefault()
      return
    }
    this.props.close()
    settings.onClose && settings.onClose()
  }

  render() {
    const { opened, close, settings, superModalOpened } = this.props

    return (
      <MUIDialog
        {...{
          disableEnforceFocus: superModalOpened,
          className: "modules_dialog",
          open: opened,
          onClose: this.onClose,
          disableEscapeKeyDown: settings.disableEscapeKeyDown,
          TransitionComponent: Slide,
          TransitionProps: { direction: "up" },
        }}
      >
        {settings.title && <DialogTitle>{settings.title}</DialogTitle>}
        {settings.contentText && <DialogContent>
          <DialogContentText>{settings.contentText}</DialogContentText>
        </DialogContent>}
        {settings.content && cloneElement(settings.content, { close, applyAction: this.onApply })}
        {settings.loadingDialog && <div className="loading-wrapper"><Loading /></div>}
        {!settings.content && !settings.loadingDialog
          && <DialogActions>
            <Button color="secondary" onClick={this.onClose}>
              {settings.cancelText || "Cancel"}
            </Button>
            {settings.buttons && settings.buttons.map((button, i) =>
              <Button
                key={i}
                color={button.type !== "danger" ? button.type : "primary"}
                className={classNames({ danger: button.type === "danger" })}
                onClick={this.onApply(button.action, button.trackType, button.trackPayload)}
              >
                {button.text}
              </Button>,
            )}
          </DialogActions>}
      </MUIDialog>
    )
  }
}

export default withNavigate(Dialog)
